/** True when the location should not reveal street address until booking. */
export function locationHidesAddress(location) {
  return Boolean(location?.hideAddress || location?.hide_address)
}
